// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC7mmAOmi1GsFwug6UWX9Dmt_7_TWpvPCc",
  authDomain: "pushnotification-2f0d6.firebaseapp.com",
  projectId: "pushnotification-2f0d6",
  storageBucket: "pushnotification-2f0d6.appspot.com",
  messagingSenderId: "930728491085",
  appId: "1:930728491085:web:25a164bca25d81970c0404",
  measurementId: "G-8Y3MFCZM7D"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
